
// const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;


// export async function authFetch(url, options = {}) {
//   const token = localStorage.getItem("token");
//   if (!options.headers) options.headers = {};
//   if (token) {
//     options.headers["Authorization"] = `Bearer ${token}`;
//   }


//   const urlObj = new URL(`${API_ENDPOINT}${url}`);


//   const res = await fetch(urlObj.toString(), options);

//   if (res.status === 498) {
//     // handleSessionExpired();
//     return Promise.reject(new Error("Session expired"));
//   }

//   return res;
// }



const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");

  if (!options.headers) {
    options.headers = {};
  }

  if (token) {
    options.headers["Authorization"] = `Bearer ${token}`;
  }

  const urlObj = new URL(`${API_ENDPOINT}${url}`);

  try {
    const res = await fetch(urlObj.toString(), options);

    // Token/session expired
    if (res.status === 498) {
      localStorage.removeItem("token");

     
      localStorage.removeItem("userId");
      localStorage.removeItem("userRole");

      // Redirect to login
      window.location.replace("/login");
      
      return Promise.reject(new Error("Session expired"));
    }

    return res;
  } catch (error) {
    throw error;
  }
}

